import {useState} from "react";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import {selfcareChangeEmailCancel} from "../../../util/request";
import LoaderSpinner from "../../loaders/LoaderSpinner";

export default function ChangeEmailConfirm(props: {isChangingEmailTo: string, setIsChangingEmailTo: (v: string|null) => void, setShowChangeEmail: (v: boolean) => void}) {
    const {customer} = useCustomer()
    const {isChangingEmailTo, setIsChangingEmailTo, setShowChangeEmail} = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)


    const abortChangingEmail = () => {
        if (loading) {
            return
        }

        setLoading(true)
        selfcareChangeEmailCancel(customer.customer_id).then(r => {
            if (r.code !== 200) {
                setErrorMessage("Noget gik galt")
                return
            }
            setSuccessMessage('Du annullerede skift af email')
            setIsChangingEmailTo(null)
            setShowChangeEmail(false)

        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen')
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <>
            <p className="selfcare-explainer-confirm">
                Vi har sendt et bekræftelseslink til den nye email {isChangingEmailTo}.
                Klik på den for at skifte din adresse.
                <br />
                Hvis du har tastet forkert eller fortryder dit skifte af email, så <button className='selfcare-button-link' onClick={abortChangingEmail}>klik her</button>.
            </p>
            {loading && <LoaderSpinner/>}
            {errorMessage && <p className="selfcare-message-error">{errorMessage}</p>}
            {successMessage && <p className="selfcare-message-success">{successMessage}</p>}
        </>
    )
}
